// imports react and next
import dynamic from "next/dynamic";
import { Image as DatoImage } from "react-datocms";
import React, { memo } from "react";

// imports utilities
import { isEmpty } from "@/utils/functions";
import { useRouter } from "next/router";

// imports components
const Button = dynamic(() => import("@/common/UI/Button"));

const ButtonList = (props) => {
  const { customClass, selectedItem, setSelectedItem, list, isClearable = false } = props;

  const router = useRouter();

  if (list?.length === 0) {
    return null;
  }

  return (
    <div className={`flex flex-wrap  ${customClass}`}>
      {list?.length > 0 &&
        list?.map((listItem, index) => (
          <Button
            key={index}
            className={`relative border-2 rounded-lg p-3 h-[49px] flex items-center justify-center uppercase font-bold text-xs tracking-[1px] ${
              selectedItem?.title === listItem?.title
                ? `border-danger ${isClearable ? "bg-white text-primary" : "bg-danger text-white"}`
                : `bg-white border-[#D9D9D9] text-primary`
            }`}
            onClick={() => {
              if (!isEmpty(listItem?.redirect)) {
                window.open(listItem?.redirect, "_ blank");
              } else {
                selectedItem?.value !== listItem?.value
                  ? setSelectedItem(listItem)
                  : isClearable && setSelectedItem({});
              }
            }}
          >
            <h6 className={`${listItem?.icon && "mr-2"} font-futuraBold text-xs tracking-[1px]`}>
              {listItem?.title}
            </h6>
            {listItem?.icon && (
              <DatoImage
                data={{
                  src: listItem?.icon?.url,
                  height: listItem?.icon?.height || 90,
                  width: listItem?.icon?.width || 90,
                  alt: listItem?.icon?.alt || "Equipment icons",
                }}
              />
            )}

            {isClearable && selectedItem?.title === listItem?.title && (
              <div
                className="absolute -right-2 -top-2 rounded-full bg-danger cursor-pointer h-6 w-6 text-white flex items-center justify-center"
                onClick={() => setSelectedItem({})}
              >
                <iconify-icon icon="raphael:cross" width="16" height="16"></iconify-icon>
              </div>
            )}
          </Button>
        ))}
    </div>
  );
};

export default memo(ButtonList);
